import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';
import { LinkCard } from '../LinkCard/LinkCard';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import type { LinkCardVariant } from '~/Partials/LinkCard/LinkCardVariant.csharp';
import styles from './StudyCard.module.css';
import type { StudyType } from './StudyType';

export interface StudyCardProps {
    linkUrl: string;
    studyName: string;
    studyType: StudyType;
    studyLevelLabel: string;
    studyLocations: string[];
    studyFormTypes: string[];
    studyDuration: string;
    variant: LinkCardVariant;
    className?: string;
}

export const StudyCard: FC<React.PropsWithChildren<StudyCardProps>> = props => {
    const {
        linkUrl,
        studyName,
        studyType,
        studyLevelLabel,
        studyLocations,
        studyFormTypes,
        studyDuration,
        variant,
        className,
    } = props;

    const studiesTypeIcon = studyType === 'campus' ? 'map-pin' : 'globe';

    const studyLocationsLabel = studyLocations.join(' \\ ');

    const TopBanner = (
        <div className={styles.Top}>
            {studyLevelLabel && (
                <div className={classNames(styles.TextWithIcon, styles.Level)}>
                    <SvgIcon iconName="student" />
                    <span className={styles.Text} title={studyLevelLabel}>
                        {studyLevelLabel}
                    </span>
                </div>
            )}
            <div className={classNames(styles.TextWithIcon, styles.Location)}>
                <SvgIcon iconName={studiesTypeIcon} />
                <span className={styles.Text} title={studyLocationsLabel}>
                    {studyLocationsLabel}
                </span>
            </div>
        </div>
    );

    const renderStudyFormTypeInformation = () =>
        studyFormTypes.length === 1 && studyDuration ? (
            <span>
                <span className={styles.TypeWithDuration}>{studyFormTypes[0]}</span>
                <span className={styles.Duration}>{studyDuration}</span>
            </span>
        ) : (
            <span>{studyFormTypes.join(', ')}</span>
        );

    const BottomBanner = (
        <div className={styles.Bottom}>
            {renderStudyFormTypeInformation()}
            <SvgIcon iconName="arrow-right" />
        </div>
    );

    return (
        <LinkCard
            className={classNames(styles.StudyCard, className)}
            variant={variant}
            linkUrl={linkUrl}
            cardLabel={studyName}
            topBanner={TopBanner}
            bottomBanner={BottomBanner}
        />
    );
};
